import React, { useState, useEffect } from "react";
import PreViewProduct from '../slider/ProdViewSlider/slider'
import Vote, {ratingVote} from './commentaire/vote'
import Price from "../pageInside/productsPrice"
import PrevviewProFilt from "../pageInside/prevviewProFilt";
import TabsElakay, {tabElakay} from "../pageInside/html/formTabs";
import imgProductLakay from '../Layout/imgs/md3.jpg' 
import {extract_Na_Ing_galeries, extract_Urls_galeriesID, compareArrays, getProductImageUrls} from '../auth/elakay-utils';
import "./ProdViewEdit.css";


let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["prodViewEdit"]?.[key] || fallback;

const keysToLowerCaseClean = (obj) => {
    if (Array.isArray(obj)) {
      return obj?.map(keysToLowerCaseClean);
    } else if (obj !== null && typeof obj === 'object') {
      return Object.keys(obj).reduce((acc, key) => {
        const cleanKey = key
          .toLowerCase()
          .replace(/\s+/g, '')        // enlève les espaces
          .replace(/[^a-z0-9_]/g, ''); // enlève les symboles (ne garde que lettres, chiffres, _)
        
        acc[cleanKey] = keysToLowerCaseClean(obj[key]);
        return acc;
      }, {});
    }
    return obj; // valeur primitive
  }

  const cleanTextKey =  (text) => {
    if (typeof text !== 'string') return text;
  
    return text
      .toLowerCase()                // minuscules
      .replace(/\s+/g, '')          // supprimer espaces
      .replace(/[^a-z0-9_]/g, '');  // supprimer symboles spéciaux sauf underscore
  }
  

  const objToArr = (a)=>{
    return a && {v: Object.values(a), k: Object.keys(a)}
}

const ProdViewEdit = (props) => {
    const [oneFilterPro, setOneFilterPro] = useState({})
    const [restAllFilterPro, setRestALLFilterPro] = useState({})
    const [allFilterPro, setALLFilterPro] = useState({})
    const [quantity, setQuantity] = useState(0) 
    const [unSeFil, setUnSefil] = useState(false)
    const [parcel, setParcel] = useState()
    const [images, setImages] = useState([])
    const [galeries, setGaleries] = useState([])
    const [filters, setFilters] = useState([]);
    const {
        infoSource,
        laguangeElakay,
        // images = [],
        getProduct,
        count,
        // quantity,
        // filters,
        // oneFilterPro,
        descriptionProduct,
        getImages
    } = props
    __setElakayInfoSource(infoSource);

    let voteRating = ratingVote(getProduct.vote)
    const priceProd = {price: getProduct.price, salePrice: getProduct.salePrice, count}

    useEffect(() => {
        // Products without filterProduct (no variants configured) must still
        // load a gallery/placeholder image -- gating this on filterProduct
        // left the gallery column permanently empty for them.
        getProduct &&  getProduct.galeries && loadImages(getProduct._id, getProduct.galeries, getProduct.filterProduct ? ProFilQuaGrToLe(getProduct.filterProduct)[0] : undefined)
        getProduct &&  getProduct.filterProduct && setALLFilterPro(ProFilQuaGrToLe(getProduct.filterProduct))
        getProduct &&  getProduct.filterProduct && setRestALLFilterPro(ProFilQuaGrToLe(getProduct.filterProduct))
        getProduct && getProduct.filterProduct && setOneFilterPro(ProFilQuaGrToLe(getProduct.filterProduct)[0])
        getProduct && getProduct.filterProduct && setNewAP(ProFilQuaGrToLe(getProduct.filterProduct)[0])
        getProduct &&  getProduct.galeries && setGaleries(getProduct.galeries)
        getProduct &&  getProduct.categoriesIDv == [] ? setFilters(getProduct.categoriesID[0].catID.filter) : setFilters([])
    }, [getProduct]);

    const setNewAP = (a)=>{
      a &&  setQuantity(a["quantity"]) 
        // setParcel(a.parcel && a.parcel.width !== null || undefined? a.parcel: restAllFilterPro[0].parcel && restAllFilterPro[0].parcel.width  !== null || undefined? restAllFilterPro[0].parcel: {}) 
        
    }
     const urls = extract_Urls_galeriesID(getProduct?.galeriesID);
     const names = extract_Na_Ing_galeries(getProduct?.galeries).names;  

    const reLoadImages =(a, b, c)=>{
        let x = b.filter["color"]
        a.filter(item =>{
            if(item.name == x){
                c(item.images) 
            }
            
        })
            
    }

    const loadImages =(Id, a, b)=> {
        const canonicalImages = getProductImageUrls(getProduct);
        if (!compareArrays(urls, names).error && b && a[0] && a[0].images?.length){
            reLoadImages(a,  b, setImages)
        }else if (canonicalImages.length) {
            setImages(canonicalImages)
        }else if (urls.length) {
            // getProductImageUrls only reads product.ProductImageUrls/product.galeries
            // (legacy embedded field) -- it never looks at the populated
            // product.galeriesID that this endpoint actually fills in, so it
            // comes back empty for most real products. `urls` above already
            // extracts exactly that.
            setImages(urls)
        }else{
        getImages(Id).then(data => {
            if (!data) {
                setImages(infoSource?.imageEmptyelakay)
            } else {
                setImages(data.galeries?.length > 0 ? [data.galeries[0].urlImg]: [infoSource?.imageEmptyelakay])
            }
        })}
    };

    const descrip = (
        <>
        <p>{getProduct.description}</p>  
        {descriptionProduct}
        </>
    )

    const ProFilQuaGrToLe =(a)=>{
        return a && a.sort(({quantity:y}, {quantity:x}) => x-y)
    }

    const stock = (a) => {
        if (a == 0) {
              return <span className="pve-stock-badge pve-stock-out">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart1}</span>
             }
             else if (a < 20) {
              return <span className="pve-stock-badge pve-stock-low">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart2} {a} {infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart3}</span>
             }
              else if (a >= 20) {
              return <span className="pve-stock-badge pve-stock-available">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart4}</span>
              }}

    const etoiteProduct = (
        <>
            {/* voteRating est NaN quand il n'y a aucun vote (0/0) : `NaN && <jsx>` s'affichait "NaN". */}
            <h5 className='p-0 m-0'><Vote rating={Number.isFinite(voteRating) ? voteRating : 0} /></h5>
        </>
        )

          let filterColor  = oneFilterPro && oneFilterPro.filter
 let arrayFilter =  objToArr(filterColor)

const filterDetail = () => {
  return (
    <div className="pve-detail-table">
      {arrayFilter && arrayFilter.k?.map((key, i) => (
        <div className="pve-detail-row" key={i}>
          <div className="pve-detail-label">{key}</div>
          <div className="pve-detail-value">{arrayFilter.v[i]}</div>
        </div>
      ))}
    </div>
  );
};


const view =()=>{
   return <div className="pve-view">
    <div className="pve-header-card">
      <div className="pve-gallery-section">
        {images?.length > 0 ? (
          <div className="pve-gallery-wrapper">
            <PreViewProduct slides={images} options={{}} infoSource={infoSource} />
          </div>
        ) : (
          <div className="pve-gallery-wrapper pve-gallery-placeholder">
            <img src={imgProductLakay} alt="" />
          </div>
        )}
      </div>
      <div className="pve-info-section">
        <div className="pve-main-info">
          <div className="pve-rating">{etoiteProduct}</div>
          <h5 className="pve-title">{getProduct.name}</h5>
          <p className="pve-description-preview">{getProduct.description}</p>
        </div>
        <div className="pve-price-section">
          <Price showAddToCartButton={false} products={priceProd}/>
        </div>
        <div className="pve-stock-section">{stock(quantity)}</div>
        <div className="pve-filters-section">
          <PrevviewProFilt
          infoSource ={infoSource}
          setQuantity={setQuantity}
          galeries={galeries}
          unSeFil={unSeFil}
          setUnSefil={setUnSefil}
          setImages={setImages}
          oneFilterPro={oneFilterPro}
          setOneFilterPro={setOneFilterPro}
          setALLFilterPro={setALLFilterPro}
          restAllFilterPro={restAllFilterPro}
          allFilterPro = {allFilterPro}
          filter ={getProduct.filters}
          // getQueryFil={getQueryFil}
          setNewAP={setNewAP}
          />
        </div>
      </div>
    </div>
    <div className="pve-details-card">
        <TabsElakay
        title={__elakayText("t001", "details")}
        >
        {tabElakay(filterDetail(), "details", "Details")}
        {tabElakay(<div className="pve-description-content">{descrip}</div>, "description", "Description")}

        </TabsElakay>
    </div>
    </div>
}
return view()
};

export default ProdViewEdit;
